import { type TFunction } from 'i18next';

import { NONE_VALUE } from '../../category-tree';
import { type CategoryNode } from '../../category-tree/types';
import { type PublisherInfo } from '../types';
export const convertPublisherInfoToCategoryNode = (
  publisherInfo: PublisherInfo,
): CategoryNode => {
  return {
    nodeId: publisherInfo.value,
    groupId: publisherInfo.value,
    label: publisherInfo.label,
    type: 'PUBLISHER',
    //출판사는 subnode 없음
    subNodes: [],
    //출판사는 parentId 없음
    parentId: undefined,
    name: publisherInfo.label,
  };
};

export const getPublisherNoneNode = (t: TFunction<'build'>): CategoryNode => {
  return {
    nodeId: NONE_VALUE,
    groupId: NONE_VALUE,
    label: t('select.unselect'),
    type: 'PUBLISHER',
    subNodes: [],
    parentId: undefined,
    name: t('select.unselect'),
  };
};

export const findPublisherNodeById = (
  publisherNodeList: CategoryNode[],
  id?: string,
) => {
  if (!id) return;

  return publisherNodeList.find(node => node.nodeId === id);
};
